import { render, staticRenderFns } from "./inviteCooperate.vue?vue&type=template&id=106773d5&scoped=true&"
import script from "./inviteCooperate.vue?vue&type=script&lang=js&"
export * from "./inviteCooperate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106773d5",
  null
  
)

export default component.exports